import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Box,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { useSnackbar } from "components/GlobalSnackbar";
import { buttonStyles } from "utils/buttonStyles";
import { dialogHeaderStyles, dialogContentStyles } from "utils/dialogStyles";

function EditZon({ open, data, onClose, onSave }) {
  const { showError } = useSnackbar();
  const [form, setForm] = useState({
    zon: "",
    bahagian_pemantau: "",
  });

  useEffect(() => {
    if (data) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      setForm({
        zon: data.zon || "",
        bahagian_pemantau: data.bahagian_pemantau || user.bahagian || "",
      });
    }
  }, [data, open]);

  // Reset form when dialog closes
  useEffect(() => {
    if (!open) {
      setForm({
        zon: "",
        bahagian_pemantau: "",
      });
    }
  }, [open]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    // Validate required fields
    if (!form.zon || form.zon.trim() === "") {
      alert("Sila masukkan nama zon yang diperlukan.");
      return;
    }
    if (!form.bahagian_pemantau || form.bahagian_pemantau.trim() === "") {
      alert("Bahagian Pemantau diperlukan.");
      return;
    }
    try {
      // Prepare data for backend - use DB column names directly
      const updateData = {
        zon: form.zon.trim(),
        bahagian_pemantau: form.bahagian_pemantau.trim(),
      };
      if (onSave) onSave(updateData);
      onClose();
    } catch (error) {
      showError("Ralat semasa mengemaskini zon. Sila cuba lagi.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={dialogHeaderStyles.info}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ color: "#fff" }}>Ubahsuai Zon</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={dialogContentStyles.light}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TextField
              label="Zon"
              name="zon"
              value={form.zon}
              onChange={handleChange}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Bahagian Pemantau"
              name="bahagian_pemantau"
              value={form.bahagian_pemantau}
              InputProps={{ readOnly: true }}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={dialogContentStyles.light}>
        <Button
          variant="contained"
          onClick={handleSave}
          size="small"
          sx={{
            ...buttonStyles.save,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          SIMPAN
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          size="small"
          sx={{
            ...buttonStyles.cancel,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          BATAL
        </Button>
      </DialogActions>
    </Dialog>
  );
}

EditZon.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditZon;
